// 连接类型
export const CONNECT_TYPE = {
    SERIAL: 'serialport',
    BLE: 'ble',
    HID: 'hid',
    WIRELESS: 'wireless'
};

// 连接状态
export const CONNECT_STATUS = {
    IDLE: 'idle',
    // 已连接
    CONNECTED: 'connected',
    // 未连接
    NOT_CONNECTED: 'not_connected',
    // 没有服务
    NOT_SERVICE: 'not_server',
    // 连接中
    CONNECTING: 'connecting',
    // 连接成功
    CONNECT_SUCCESS: 'connect_success',
    // 连接失败
    CONNECT_FAIL: 'connect_fail',
    // 连接失败
    CONNECT_ERROR: 'connect_error',
    // 连接超时
    CONNECT_TIMEOUT: 'connect_timeout',
    // 取消连接
    CONNECT_CANCEL: 'connect_cancel',
};

//扫描状态
export const SCAN_STATUS = {
    SCAN_READY: 'scan_ready',
    // 扫描中
    SCANNING: 'scanning',
    // 扫描成功
    SCAN_SUCCESS: 'scan_success',
    // 扫描失败
    SCAN_FAIL: 'scan_fail',
    // 扫描超时
    SCAN_TIMEOUT: 'scan_timeout',
    // 取消扫描
    SCAN_CANCEL: 'scan_cancel'
};

export const CH340 = {
    PRODUCT_ID: 29987, //0x7523
    VERDOR_ID: 6790,
}